/*
 * @Date: 2025-08-20 15:06:35
 */
import { createKAxios } from "@kukefe/kkutils";
import axios from "axios";

import { version } from "../../../package.json";
import { buildUUID } from "../uuid";
import { interceptor } from "./interceptor";

const browserInfo = require("browser-info");
const ip = require("ip");

const headers = {
  "Content-Type": "application/json",
  "kk-request-id": `${buildUUID()}${new Date().getTime()}`,
  "kk-version": version,
  "kk-from": "web",
  "kk-os": browserInfo.os,
  "kk-modle": browserInfo.name,
  "kk-ip": ip.address() || "",
  "org-id": "",
  "tenant-id": "",
};

const defaultConfig = {
  baseURL: process.env.VUE_APP_BASE_API,
  headers,
  interceptor, // axios 拦截器
  timeout: 150000,
  appId: process.env.VUE_APP_ENCRYPTION_APPID,
  appKey: process.env.VUE_APP_ENCRYPTION_APPKEY,
  secret: process.env.VUE_APP_REQUEST_ENCRYPTION_KEY
};

export const http = createKAxios(axios, defaultConfig);

export const http1 = createKAxios(axios, {
  ...defaultConfig,
  baseURL: process.env.VUE_APP_BASE_API + "-core",
});

export const http2 = createKAxios(axios, {
  ...defaultConfig,
  baseURL: process.env.VUE_APP_BASE_API + "-api",
});
